// extracted by mini-css-extract-plugin
module.exports = {"ServiceSettings":"ServiceSettings___1Y0Fe","title":"title___1DQzM"};